const SCHEMA_VERSION = 1;

const STATUS = { PASS: 'pass', FAIL: 'fail', WARN: 'warn', INFO: 'info' };

const CHECK_ID = {
  CORS: 'cors',
  CSP: 'csp',
  OTTU_PG: 'ottu_pg',
  JAZZ: 'jazz',
  IMPLEMENTATION: 'implementation',
};

module.exports = { SCHEMA_VERSION, STATUS, CHECK_ID };
